import { render } from "./djylResource.vue?vue&type=template&id=7ad6712d&scoped=true"
import script from "./djylResource.vue?vue&type=script&lang=js"
export * from "./djylResource.vue?vue&type=script&lang=js"

import "./djylResource.vue?vue&type=style&index=0&id=7ad6712d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad6712d"]])

export default __exports__